import * as Sentry from '@sentry/nextjs';

/**
 * Set the current user in Sentry context.
 *
 * Called on login, register, firebase login, fetchUser, and setUserFromPostCheckout.
 * The user ID matches tabootv_user_id used in Axiom logs, enabling
 * cross-referencing between Sentry errors/replays and Axiom log traces.
 */
export function identifySentryUser(userId: number, isSubscribed: boolean): void {
  Sentry.setUser({ id: String(userId) });
  Sentry.setTag('subscribed', String(isSubscribed));
}

/**
 * Clear the Sentry user context.
 *
 * Called on logout and when auth verification fails.
 */
export function clearSentryUser(): void {
  Sentry.setUser(null);
}
